import React from "react";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import logoIcon from "../../assets/images/logoIcon.svg";
import { ROUTES } from "../../utils/routes";
import { Grid, Typography } from "@mui/material";

const CheckEmail = () => {
    return (
        <div className="loginPage signupbg wrap d-flex align-items-center justify-content-center" style={{ minHeight: '100vh', padding: '20px' }}>
            <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-10 col-sm-12 col-12 mx-auto">
                <div className="bg-white p-5 rounded-4 shadow-sm text-center d-flex flex-column align-items-center justify-content-center" style={{ maxWidth: '600px', margin: '0 auto' }}>
                    <div className="logoIcon mb-4">
                        <Image src={logoIcon} alt="Logo Icon" style={{ maxHeight: '60px' }} />
                    </div>
                    <Typography variant="h4" className="mb-3 fw-bold">
                        Check your <span className="textGradient">Email</span>
                    </Typography>
                    <Typography variant="body1" className="mb-4 text-muted" style={{ maxWidth: '80%' }}>
                        We've sent a verification link to your email address. Please check your inbox and click the link to verify your account.
                    </Typography>
                    <Link to={ROUTES.LOGIN} className="btnPrimary text-decoration-none px-5 py-2">
                        Back to Login
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CheckEmail;
